export default {
  mediaId: null,
  roomMediaFiles: [],
  roomGroupId: 'default',
  uploadRoomMediaFiles: [],
  allowedFileExts: '.mp3,.ogg,.mp4,.webm',
  audioFileExts: '.mp3,.ogg',
  videoFileExts: '.mp4,.webm',
  init: false
}
